import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { Body1, Body5, Container, Page } from '@ui';
import { SupportEmail } from '@ui/SupportEmail';
import { FlatButton } from '@ui/buttons';
import { signOut } from '@services/authentication';
import { logError } from '@utils/sentry';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

function AccountInitError() {
  const [isSigningOut, setIsSigningOut] = React.useState(false);

  React.useEffect(() => {
    logError(new Error('AccountInitError'));
  }, []);

  const onSignOutClick = async () => {
    setIsSigningOut(true);
    const result = await signOut(true);
    if (!result) {
      setIsSigningOut(true);
    }
  };

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <Page>
          <Container>
            <Body1 bold>Something went wrong. Please refresh and try again.</Body1>
            <Container top={16}>
              <Body5>
                Please contact <SupportEmail /> if issue persists.
              </Body5>
            </Container>
            <Container top={48}>
              {isSigningOut ? (
                <FlatButton disabled onClick={() => null}>
                  Signing Out...
                </FlatButton>
              ) : (
                <FlatButton onClick={onSignOutClick}>Sign Out</FlatButton>
              )}
            </Container>
          </Container>
        </Page>
      </Body>
    </PageWrapper>
  );
}

export default AccountInitError;
